import { useTranslation } from 'react-i18next';
import { Form, type FormListFieldData, TextAreaInput, type TextAreaItemProperties } from 'ui';

type P = {
  disabledEdit: boolean;
  field: FormListFieldData;
  item: TextAreaItemProperties;
  placeholder: string;
};

const BulkInput = ({ disabledEdit, field, item, placeholder }: P) => {
  const { t } = useTranslation();

  return (
    <Form.List name={[field.name, 'bulk']}>
      {(fields) =>
        fields.map((fieldOption) => (
          <TextAreaInput
            input={{
              'data-test-id': `activity_add-bulk-${fieldOption.name}`,
              disabled: disabledEdit,
              placeholder: t(placeholder),
            }}
            item={{
              ...fieldOption,
              extra: item.extra,
              label: item.label,
              rules: [{ required: true }],
            }}
            key={fieldOption.key}
          />
        ))
      }
    </Form.List>
  );
};

export default BulkInput;
